import right from 'images/cscec3b/tuijian-r';
import rightw from 'images/cscec3b/tuijian-rw';
import left from 'images/cscec3b/tuijina-l';
import leftw from 'images/cscec3b/tuijina-lw';
import { DeviceContext } from 'libs/contexts';
import { webps } from 'libs/imgs';
import React, { useContext } from 'react';
import MaterialsCard from './MaterialsCard';

webps[left] = leftw;
webps[right] = rightw;

function ProductDetailRecommend(
  {
    recommendSpuList,
  }: {
    recommendSpuList: any[];
  },
  ref,
) {
  const { buildImgSrc } = useContext(DeviceContext);

  return (
    <>
      <div className="recommend" ref={ref}>
        <div className="recommendName">
          <img src={buildImgSrc(left)} alt="" />
          <span>为您推荐</span>
          <img src={buildImgSrc(right)} alt="" className="right" />
        </div>
        <div className="recommendList">
          {recommendSpuList.slice(0, 6).map((item, key) => (
            <div key={key} className="recommendCardWrapper">
              <MaterialsCard
                isRecormend={true}
                key={key}
                name={`${item.brand} ${item.name}`}
                lowestPrice={item.lowestPrice}
                highestPrice={item.lowestPrice}
                sysNo={item.sysNo}
                unit={item.unit}
                mainImage={item.images[0] || ''}
                shopName={item.shopName}
                skuCount={item.skuCount}
                images={item.images}
                href={`/product/detail?id=${item.bestSkuSysNo}`}
                sellCountString={item.sellCountString}
                productTagServiceList={item.productTagServiceList}
                productTagImageList={item.productTagImageList}
                productTagTitleList={item.productTagTitleList}
              />
            </div>
          ))}
        </div>
      </div>
      <style jsx>{`
        .recommend {
          margin: 10px 0 16px;
        }

        .recommendName {
          text-align: center;
          height: 56px;
          line-height: 56px;
          font-size: 16px;
          color: #333333;
        }

        .recommendName span {
          padding: 0 15px;
          font-weight: bolder;
        }

        .recommendName img {
          height: 12px;
        }

        .recommendList {
          display: flex;
          padding: 0 16px;
          justify-content: space-between;
          flex-wrap: wrap;
          width: 100%;
        }

        .recommendCardWrapper {
          margin-bottom: 5px;
          width: 50%;
        }

        .recommendCardWrapper :global(.box) {
          width: calc(100% - 5px);
        }
      `}</style>
    </>
  );
}

export default React.forwardRef(ProductDetailRecommend);
